import {
  Alert,
  Collapse,
  Snackbar,
  useMediaQuery,
  useTheme,
} from "@mui/material";

interface IResponsiveAlert {
  errorOpen: boolean;
  errorMessage?: string;
  severity?: "error" | "warning" | "info" | "success";
  autoHideDuration?: number | null;
  setErrorOpen?: (open: boolean) => void;
}

const ResponsiveAlert = ({
  errorOpen,
  errorMessage = "Unexpected error. Please try again or contact support.",
  severity = "error",
  autoHideDuration = 5000,
  setErrorOpen,
}: IResponsiveAlert) => {
  const theme = useTheme();
  const isMdDown = useMediaQuery(theme.breakpoints.down("md"));

  const renderAlert = () => (
    <Alert severity={severity} sx={{ marginBottom: theme.spacing(2) }}>
      {errorMessage}
    </Alert>
  );

  return isMdDown ? (
    <Snackbar
      id="responsive-alert"
      open={errorOpen}
      autoHideDuration={autoHideDuration}
      onClose={() => setErrorOpen && setErrorOpen(false)}
      sx={{ justifyContent: "center" }}
    >
      {renderAlert()}
    </Snackbar>
  ) : (
    <Collapse id="responsive-alert" in={errorOpen}>{renderAlert()}</Collapse>
  );
};

export default ResponsiveAlert;
